<script setup>
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/24/outline'

defineProps({
    meta: {
        type: Object,
        required: true,
    },
})

const translateLabel = (label) => {
    const translations = {
        'pagination.previous': 'Předchozí',
        'pagination.next': 'Další',
    }
    return translations[label] || label
}

const isPrevious = (label) => {
    return label === 'pagination.previous' || label.includes('Previous')
}

const isNext = (label) => {
    return label === 'pagination.next' || label.includes('Next')
}
</script>

<template>
    <nav
        v-if="meta?.links && meta.links.length > 3"
        class="mt-8"
        role="navigation"
        aria-label="Stránkování"
    >
        <div class="flex flex-wrap items-center justify-center gap-2">
            <component
                v-for="(link, index) in meta.links"
                :is="link.url ? 'Link' : 'span'"
                :href="link.url"
                :key="`pagination-${index}-${link.label}`"
                :aria-label="
                    isPrevious(link.label)
                        ? 'Přejít na předchozí stránku'
                        : isNext(link.label)
                          ? 'Přejít na další stránku'
                          : `Přejít na stránku ${link.label}`
                "
                :aria-current="link.active ? 'page' : undefined"
                class="group relative flex min-w-[44px] items-center justify-center rounded-lg border px-3 py-2 text-sm font-medium transition-all duration-200 ease-in-out focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 focus:outline-none"
                :class="{
                    // Active state
                    'bg-brand-orange border-orange-600 text-white shadow-md': link.active,

                    // Disabled state
                    'cursor-not-allowed border-gray-200 bg-gray-100 text-gray-400': !link.url,

                    // Enabled state
                    'border-gray-300 bg-white text-gray-700 hover:border-gray-400 hover:bg-gray-50 hover:text-gray-900':
                        link.url && !link.active,

                    // Special styling for prev/next buttons
                    'px-4': isPrevious(link.label) || isNext(link.label),
                }"
            >
                <!-- Previous arrow -->
                <ChevronLeftIcon
                    v-if="isPrevious(link.label)"
                    class="mr-1 h-4 w-4"
                />

                {{ translateLabel(link.label) }}

                <!-- Next arrow -->
                <ChevronRightIcon
                    v-if="isNext(link.label)"
                    class="ml-1 h-4 w-4"
                />
            </component>
        </div>

        <!-- Mobile-friendly info -->
        <div class="mt-4 text-center text-sm text-gray-500 sm:hidden">
            Stránka {{ meta.current_page }} z {{ meta.last_page }}
        </div>
    </nav>
</template>
